export default __webpack_public_path__ + "static/media/icon-evolution-dark.301e87f5.svg";